import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { useRef, useState } from 'react';

const CreaProyecto = ({ cliente, onSave }) => {
    const [sigla, setSigla] = useState('');
    const [proyNombre, setProyNombre] = useState('');
    const [procesa, setProcesa] = useState(false);

    const toastProy = useRef();

    const handleGuardar = () => {
        if (sigla.length === 0 || proyNombre.length === 0) {
            toastProy.current.show({ severity: 'warn', summary: 'Atencion', detail: 'Debe llenar los campos Sigla y Nombre' });
            return;
        }
        setProcesa(true);
        const dataGuardar = {
            cliente: cliente.clienteId,
            sigla: sigla.toUpperCase(),
            nombre: proyNombre.toUpperCase()
        };
        onSave(dataGuardar);
    };

    return (
        <div className="card">
            <Toast ref={toastProy} />
            <div className="formgrid grid p-fluid mb-3">
                <div className="field col-12 md:col-6">
                    <label>Sigla Proyecto: </label>
                    <InputText value={sigla} onChange={(evt) => setSigla(evt.target.value)} placeholder="Sigla para el Proyecto" disabled={procesa} style={{ textTransform: 'uppercase' }} maxLength={50}/>
                </div>
                <div className="field col-12 md:col-6">
                    <label>Nombre Proyecto: </label>
                    <InputText value={proyNombre} onChange={(evt) => setProyNombre(evt.target.value)} placeholder="Nombre del Proyecto" disabled={procesa} style={{ textTransform: 'uppercase' }} maxLength={100} />
                </div>
                <div className="field col-12 md:col-6">
                    <span></span>
                </div>
                <div className="field col-12 md:col-6">
                    <Button label="Guardar" onClick={handleGuardar} loading={procesa} />
                </div>
            </div>
        </div>
    );
};

export default CreaProyecto;
